<div class="backtile">
    <h1 class="title">About Angular Community</h1>
    <br>
    <p class="text">One of the world's first Angular meetups started here in Utah. This is a great place to learn about Angular and collaborate and network with other developers. Meetups are held the fourth Tuesday of every month on the south end of Salt Lake Valley.
        To present at the group, message the organizers.
    </p>
    <br>
    <h2 class="subheading"> The Organizer Team</h2>
    <br>
    <p class="text">Erik Slack</p>
    <p class="text">Brooke Avery</p>

</div>
